import { render, staticRenderFns } from "./TabApprovals.vue?vue&type=template&id=0d43f2cc"
import script from "./TabApprovals.vue?vue&type=script&lang=js"
export * from "./TabApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports